<template>
  <img v-lazy="lazyOptions" :alt="alt" :title="title" :class="classes" />
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  src: { type: String, required: true, default: "" },
  alt: { type: String, default: "" },
  title: { type: String, default: "" },
  classes: { type: [String, Array, Object], default: "" },
  loading: { type: String, default: "" }, // optional loading image
  error: { type: String, default: "" }, // optional error image
});

const lazyOptions = computed(() => {
  const options = {
    src: props.src,
    lifecycle: {
      loading: (el) => {
        console.log("image loading", el);
      },
      error: (el) => {
        console.log("image error", el);
      },
      loaded: (el) => {
        console.log("image loaded", el);
      },
    },
  };
  if (props.loading) options.loading = props.loading;
  if (props.error) options.error = props.error;
  return options;
});
</script>
